import type { Theme } from '@mui/material/styles';

import { typedStyles } from '@/utils/styleUtils';

const contentWidth = (spacing: Theme['spacing']) => ({
  width: `min(${384 + window.parseInt(spacing(12))}px, 100%)`,
  paddingX: spacing(6),
});

export const styles = typedStyles({
  form: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'auto',
    minHeight: 0,
    paddingTop: 9,
  },

  content: ({ spacing }) => ({
    ...contentWidth(spacing),

    flex: 1,
    paddingBottom: 8,
  }),

  title: {
    marginBottom: 4,
  },

  section: {
    '& + &': {
      marginTop: 6,
    },
  },

  sectionTitle: {
    marginBottom: 3,
  },

  footer: ({ spacing }) => ({
    width: '100%',
    padding: spacing(2, 0, 3),
  }),

  controls: ({ spacing }) => ({
    ...contentWidth(spacing),

    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(75px, 1fr))',
    margin: '0 auto',
    gap: 2,
  }),

  errorToast: ({ spacing }) => ({
    ...contentWidth(spacing),

    position: 'sticky',
    top: spacing(-9),
    padding: spacing(3, 0, 2),
    margin: spacing(-9, -4, 1),
    backgroundColor: 'background.paper',
  }),
});
